import { workspaceRegistry } from './WorkspaceRegistry';
import { SlackSetupScreen } from '../screens/workspace-setup/SlackSetupScreen';
import { BrowserSetupScreen } from '../screens/workspace-setup/BrowserSetupScreen';
// import { PlerionPlatformSetupScreen } from '../screens/workspace-setup/PlerionPlatformSetupScreen';
import { WorkspaceType } from '../apis/workspace-registry';

// Browser detection utility
import { getBrowserType } from '../../../utils/browserUtils';
// Get extension image name based on browser
function getExtensionImageName(): string {
  const browserType = getBrowserType();
  return browserType === 'firefox' ? 'firefox-extension' : 'chrome-extension';
}

// Register workspaces

workspaceRegistry.register(
  {
    id: WorkspaceType.SLACK,
    type: WorkspaceType.SLACK,
    name: 'Slack',
    description:
      'Allows me to join conversations and help with security in Slack.',
    icon: '💬',
    tags: ['communication', 'collaboration'],
    category: 'Messaging',
    image: {
      name: 'slack-secret',
      type: 'resourceType',
    },
    buttonText: 'Configure Slack',
    buttonColor: 'purple',
    status: 'available',
    availableFrom: '2025 Q2',
    configurable: true,
  },
  SlackSetupScreen,
);

workspaceRegistry.register(
  {
    id: WorkspaceType.BROWSER,
    type: WorkspaceType.BROWSER,
    name: 'Browser extension',
    description:
      'Allows me to help with security directly in AWS, Azure, GCP, and GitHub.',
    icon: '🌐',
    tags: ['integration', 'productivity'],
    category: 'Browser',
    image: {
      name: getExtensionImageName(),
      type: 'resourceType',
    },
    buttonText: 'Install Extension',
    buttonColor: 'blue',
    status: 'available',
    autoDetect: true,
    configurable: true,
  },
  BrowserSetupScreen,
);
